import React from 'react';
import BiSpan from '@wix/da-bi/pkg/Components/BiSpan';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { useSubmitMenuItem } from '../../useSubmitMenuItem';
var MobileSubmitMenuItem = function (_a) {
    var type = _a.type, link = _a.link, modalType = _a.modalType, modalOptions = _a.modalOptions, verificationAction = _a.verificationAction, isLegacyHeader = _a.isLegacyHeader, className = _a.className, tabIndex = _a.tabIndex, children = _a.children;
    var _b = useSubmitMenuItem({
        modalType: modalType,
        link: link,
        verificationAction: verificationAction,
        type: type,
        modalOptions: modalOptions,
        isLegacyHeader: isLegacyHeader,
    }), onClick = _b.onClick, href = _b.href, biData = _b.biData;
    if (href) {
        return (React.createElement(BiLink, { href: href, biData: biData, className: className, tabIndex: tabIndex, onClick: onClick }, children));
    }
    return (React.createElement(BiSpan, { biData: biData, className: className, tabIndex: tabIndex, onClick: onClick }, children));
};
MobileSubmitMenuItem.displayName = 'MobileSubmitMenuItem';
export default MobileSubmitMenuItem;
//# sourceMappingURL=MobileSubmitMenuItem.js.map